import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Grid, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { RHFRadioGroup, RHFSelectField } from "../../../common/hook-form";
import { formatCurrency } from "../../../helpers/UtilityHelper";
import { addDays, format } from "date-fns";
import { apiConstants, post } from "../../../common/constants";
import _ from 'lodash'
import { LoadingButton } from "@mui/lab";
import { useGetCouriersQuery } from "../../../redux/commonRTKPersist";
import { CourierSkeleton } from "../../../common/Skeletons";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY } from '../../../styles/foundation/colors';


function SelectCourier({ setActiveStep, formData, pickupLocations, creatingOrder, merchantId }) {
    const [newCourier, setNewCourier] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { data: allCouriers } = useGetCouriersQuery()
    const { watch } = useFormContext();
    const courierSelection = watch('courier_type')
    const [dataFetched, setDataFetched] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { blendedData } = useSelector(state => state?.report);


    useEffect(() => {
        if (formData && courierSelection === "Other" && !dataFetched) {
            setIsLoading(true)
            const selectedAddress = pickupLocations?.find(loc => loc.id === formData?.pickupLocation);
            const pickup_details = {
                from_address: selectedAddress?.address_line,
                from_city: selectedAddress?.city,
                from_country: selectedAddress?.country,
                from_name: selectedAddress?.name,
                from_pincode: selectedAddress?.pincode,
                from_state: selectedAddress?.state,
                from_phone_number: selectedAddress?.contactNumber,
                from_email: selectedAddress?.email,
                gstin: selectedAddress?.gstin
            }

            let length = _.sumBy(formData?.shipment_detail, "item_length")
            let breadth = _.sumBy(formData?.shipment_detail, "item_breadth")
            let height = _.sumBy(formData?.shipment_detail, "item_height")
            let weight = _.sumBy(formData?.shipment_detail, "item_weight")
            if (pickup_details) {
                post(`${apiConstants.BASE_LOCAL}${apiConstants.SHIPMENT_RATE_CALCULATOR}`, {
                    orderType: "RVP",
                    // to: parseInt(formData.delivery_details?.to_pincode),
                    to: parseInt(pickup_details?.from_pincode),
                    from: parseInt(formData.pickup_details?.from_pincode),
                    paymentType: formData?.payment_mode.toLowerCase() === "prepaid" ? "PREPAID" : "COD",
                    "length": length,
                    "breadth": breadth,
                    "height": height,
                    "weight": weight,
                    "dispatchMode": "SURFACE",
                    "codAmount": Number(formData.cod_amount) || 0,
                    "isMerchant": true,
                    onlyCouriersAsPerRuleMapping: true, checkServiceable: true,
                    merchantOid: merchantId,
                    invoiceValue: formData?.invoice_value

                }).then((res) => {
                    setIsLoading(false)
                    const pricing = res?.data;
                    const newCourier = allCouriers?.map((d) => {
                        const updatedCourier = { ...d };
                        pricing.forEach((t) => {
                            if (t.provider?.id === updatedCourier.prozoId) {
                                updatedCourier.priceAfterTax = t.priceAfterTax;
                                updatedCourier.providerMinTatDays = t.providerMinTatDays;
                                updatedCourier.providerMaxTatDays = t.providerMaxTatDays;
                                updatedCourier.parent = t.provider?.parent;
                                updatedCourier.providerDispatchMode = t.provider?.dispatch_mode;
                                updatedCourier.providerServiceTypePrimary = t.provider?.service_type_primary;
                            }
                        });
                        return updatedCourier;
                    })
                    let filteredCouriers = newCourier.filter(item =>
                        item.priceAfterTax &&
                        item.type === 'RVP' &&
                        item.supported_shipment === 'B2C'
                    )
                    // Deduplicate by parent + dispatch mode — keep the cheapest entry per combination
                    const parentMap = new Map()
                    filteredCouriers.forEach(c => {
                        const key = (c.parent || c.name) + '|' + (c.providerDispatchMode || '')
                        const existing = parentMap.get(key)
                        if (!existing || c.priceAfterTax < existing.priceAfterTax) {
                            parentMap.set(key, c)
                        }
                    })
                    filteredCouriers = Array.from(parentMap.values())
                    const now = new Date();
                    filteredCouriers.forEach(shipment => {
                        let minTatDays = shipment.providerMinTatDays || 0;
                        let maxTatDays = shipment.providerMaxTatDays || 0;
                        shipment.minDeliveryDate = format(addDays(now, minTatDays), 'dd, MMM');
                        shipment.maxDeliveryDate = format(addDays(now, maxTatDays), 'dd, MMM');
                    });
                    setNewCourier(filteredCouriers);
                    setDataFetched(true);
                }).catch((err) => {
                    console.log(err)
                    enqueueSnackbar(err?.response?.data?.message || "Error fetching pricing", { variant: "error" });
                    setIsLoading(false)
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData, courierSelection, dataFetched])

    return (
        <>
            {(isLoading) ? <CourierSkeleton /> :
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {blendedData ?
                                <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                                    {
                                        label: "As per Recommendation Rules",
                                        value: "Prozo Choice",
                                    },
                                ]}
                                /> :
                                <RHFRadioGroup label="Courier Selection" name="courier_type" options={[
                                    {
                                        label: "As per Recommendation Rules",
                                        value: "Prozo Choice",
                                    },
                                    { label: "Other Courier", value: "Other" },
                                ]}
                                />
                            }
                        </Grid>
                        {courierSelection === 'Other' && (
                            <Grid item xs={10}>
                                <RHFSelectField
                                    variant="filled"
                                    width="100%"
                                    name="courierPartner"
                                    label="Courier Partner"
                                    noOptionsText='No courier partner available for this pickup location'
                                    options={(newCourier)?.filter(row => !row.isExternal).map((c) => {
                                        const hasTat = c.providerMinTatDays !== undefined && c.providerMaxTatDays !== undefined && c.providerMaxTatDays > 0
                                        return {
                                            label: (
                                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1.5 }}>
                                                    <Typography sx={{
                                                        fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: NAVY,
                                                        flex: '1 1 0', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                                    }}>
                                                        {(c?.parent || c?.name)}{(c?.providerDispatchMode || c?.providerServiceTypePrimary) ? ` - ${c.providerDispatchMode || c.providerServiceTypePrimary}` : ''}
                                                    </Typography>
                                                    <Chip label={formatCurrency(c?.priceAfterTax)} size='small'
                                                        sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.bold, bgcolor: '#e8f5e9', color: '#2e7d32', flexShrink: 0 }}
                                                    />
                                                    <Typography sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.medium, color: NAVY, flexShrink: 0, minWidth: 90, textAlign: 'center' }}>
                                                        {hasTat ? `TAT: ${c.providerMinTatDays}\u2013${c.providerMaxTatDays}d` : 'TAT: N/A'}
                                                    </Typography>
                                                    <Chip label={hasTat ? `EDD: ${c.minDeliveryDate}\u2013${c.maxDeliveryDate}` : 'EDD: N/A'} size='small'
                                                        sx={{ fontFamily: FONT, fontSize: '0.68rem', fontWeight: WEIGHT.bold, bgcolor: '#e3f2fd', color: '#1565c0', flexShrink: 0 }}
                                                    />
                                                </Box>
                                            ),
                                            value: c?.prozoId
                                        };
                                    })}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Stack direction="row" columnGap={1} sx={{ mt: 3 }}>
                                <Button variant="contained" size="small" color="error" onClick={() => setActiveStep(3)}>Back</Button>
                                <LoadingButton loading={creatingOrder} variant="contained" size="small" type="submit">Create Shipment</LoadingButton>
                            </Stack>
                        </Grid>
                    </Grid>
                </>
            }
        </>
    )
}

export default SelectCourier;